import { call, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash';
import { Trip, TripService } from '../../../../../entities/Trip';
import { Image, SliderImage } from '../../../../../entities/Photo/interfaces';
import { getRepTripError, getRepTripRequest, getRepTripSuccess } from './actions';
import { GET_REPORT_TRIP_REQUEST } from './constants';

function* getRepTripSaga(action: ReturnType<typeof getRepTripRequest>) {
  const { payload } = action;
  try {
    const trip: Trip = yield call(TripService.getTrip, { id: payload, params: {} });
    let data = [] as SliderImage[] | any;

    const trailerNumber = get(trip, 'trailer.document.number', '');
    const vehicleNumber = get(trip, 'vehicle.document.number', '');
    data = [
      ...get(trip, 'vehicle.document.pictures', []).map((v: Image, indx: number) => ({
        ...v,
        type: 'vehicle',
        docIndex: null,
        picIndex: indx,
        docNumber: vehicleNumber,
      })),
      ...get(trip, 'trailer.document.pictures', []).map((v: Image, indx: number) => ({
        ...v,
        type: 'trailer',
        docIndex: null,
        picIndex: indx,
        docNumber: trailerNumber,
      })),
    ];
    // @ts-ignore
    trip.driver?.documents.forEach(({ number, pictures }: Document, index: number) => {
      data.push(
        ...pictures.map((v: Image, indx: number) => ({
          ...v,
          type: 'driver',
          docIndex: index,
          picIndex: indx,
          docNumber: number,
        })),
      );
    });

    yield put(getRepTripSuccess(data));
  } catch (error: any) {
    yield put(getRepTripError(error));
  }
}

export function* reportSagaWatcher() {
  yield takeLatest(GET_REPORT_TRIP_REQUEST, getRepTripSaga);
}
